/** Canonical self-serve seat caps — shared by packageAccess and plan recommendations. */
export const RECOMMENDATION_PLAN_SEAT_LIMITS = {
  LAUNCH: { backOffice: 1, field: 10 },
  GROWTH: { backOffice: 3, field: 30 },
  SCALE: { backOffice: 5, field: 50 },
};

export const SCALE_SELF_SERVE_MAX = {
  backOffice: RECOMMENDATION_PLAN_SEAT_LIMITS.SCALE.backOffice,
  field: RECOMMENDATION_PLAN_SEAT_LIMITS.SCALE.field,
};
